import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { motion } from "framer-motion";

import { PostList } from "~/components/blog/post-list";
import { item, Layout } from "~/components/site/layout";
import { ROUTE_DATA } from "~/lib/constants";
import { getMeta } from "~/lib/get-meta";
import { getUrls } from "~/lib/get-urls";
import { getPosts } from "~/lib/post";

const { desc, path, title } = ROUTE_DATA.blog;

export function loader({ request }: LoaderFunctionArgs) {
  return { urls: getUrls({ path, request }) };
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return data ? getMeta({ desc, title, urls: data.urls }) : [];
};

export default function Blog(): JSX.Element {
  return (
    <Layout>
      <section className="grow max-w-none prose dark:prose-invert section-first">
        <div className="container grid lg:grid-cols-3 items-start lg:gap-16">
          <motion.div variants={item} className="lg:sticky top-16">
            <h1 className="eyebrow">Blog</h1>
            <h2 className="mt-0 mb-6">News & updates</h2>
          </motion.div>
          <motion.div variants={item} className="col-span-2">
            <PostList posts={getPosts()} />
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
